export default __webpack_public_path__ + "static/media/submit.74177003.png";